// extracted by mini-css-extract-plugin
export var container = "HeadingWithForm-module--container--3HUR3";
export var bg = "HeadingWithForm-module--bg--1c3HG";
export var heading = "HeadingWithForm-module--heading--2zrJ3";
export var superText = "HeadingWithForm-module--super-text--1el_R";
export var gatedH1 = "HeadingWithForm-module--gated-h1--UzIgY";
export var lightFont = "HeadingWithForm-module--light-font--37t07";
export var form = "HeadingWithForm-module--form--2sIE5";
export var excerpt = "HeadingWithForm-module--excerpt--GS11Y";
export var heroImage = "HeadingWithForm-module--hero-image--220Xy";
export var sparkAwards = "HeadingWithForm-module--spark-awards--3fzy5";
export var sparkHeader = "HeadingWithForm-module--spark-header--3Q-HV";
export var expand = "HeadingWithForm-module--expand--2ZNVt";